import { t } from '../i18n';
interface Props {
  level: number; // 0.0〜1.0
  isMuted: boolean;
  isCapturing: boolean;
  isSpeaking: boolean;
}

export default function AudioMeter({ level, isMuted, isCapturing, isSpeaking }: Props) {
  const displayLevel = isMuted ? 0 : level;
  const percent = Math.round(displayLevel * 100);

  return (
    <div className="card">
      <div className="card-title">{t('音声入力', 'Audio input')}</div>

      <div className="audio-meter-label">
        <span>{isMuted ? t('🔇 ミュート中', '🔇 Muted') : t('🎙️ 入力レベル', '🎙️ Input level')}</span>
        <span>{isCapturing ? `${percent}%` : '—'}</span>
      </div>

      <div className="audio-meter">
        <div
          className="audio-meter-bar"
          style={{ width: `${percent}%` }}
        />
      </div>

      {isSpeaking && (
        <div style={{ marginTop: '0.5rem' }}>
          <span className="speech-indicator">
            <span className="speech-wave">
              <span />
              <span />
              <span />
            </span>
            {t('認識中', 'Listening')}
          </span>
        </div>
      )}

      {!isCapturing && (
        <p style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: '0.5rem' }}>
          {t('翻訳開始ボタンを押してください', 'Press Start translating')}
        </p>
      )}
    </div>
  );
}
